import React, { useState, useEffect } from 'react';
import { Parallax } from 'react-parallax';
import { useNavigate } from 'react-router-dom';
import './Projects.css';

function Projects() {
  const [showProjectOne, setShowProjectOne] = useState(false);
  const [showProjectTwo, setShowProjectTwo] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (showProjectOne) {
      navigate('/project-one-description');
    } else if (showProjectTwo) {
      navigate('/project-two-description');
    }
  }, [showProjectOne, showProjectTwo, navigate]);

  return (
    <Parallax
      bgImage="/assets/StudyPlace5.webp"
      strength={300}
      className="parallax-section"
    >
      <div id="projects" className="section-content">
        <h2>Projects</h2>

        <div className="project-buttons-container">
          <button className="project-button" onClick={() => setShowProjectOne(true)}>
            Stego
          </button>
          <button className="project-button" onClick={() => setShowProjectTwo(true)}>
            Recontext
          </button>
        </div>


      <div className="coming-soon-section">
          <p className="coming-soon-text">Coming Soon</p>
          <button
            className="project-button"
            onClick={() => window.location.href = "https://midguardr-website-v1.vercel.app"}
          >
            MidGuardr
          </button>
        </div>
      </div>

      {/* Image Description */}
      <div className="image-description">Image: Workspace</div>
    </Parallax>
  );
}

export default Projects;
